import { logger } from 'lib/slardar-utils'
import cookie from 'cookie'
import { handleAsPath } from 'lib/utils'

// 快速 获取 用户信息
const getCityName = (asPath: string, req?: any, defaultCity = '北京') => {
  try {
    const parsedCityName = cookie.parse(
      req?.headers.cookie || window?.document?.cookie
    )['city_name']

    return decodeURIComponent(
      parsedCityName ||
        asPath?.match(/[&?]cityName=([^&#]+)/)?.[1] ||
        defaultCity
    )
  } catch (e) {
    // noop
    logger.warn('[get cityName]:failed', e?.message)
  }
  return defaultCity
}

export default getCityName
